import { memo } from "react";
import Columns from "./Columns";
import type { ColumnsProps } from "./types";

const Current = (props: ColumnsProps) => (
    <Columns
        {...props}
        slotProps={{
            collection: {
                sx: {
                    justifySelf: 'flex-end',
                    justifyItems: 'flex-end'
                }
            },
            column: {
                sx: {
                    width: 'fit-content',
                    textAlign: 'right'
                }
            }
        }}
        getComparisonColumn={({ current }) => current}
    />
);

export default memo(Current);
